<template>
  <div class="claim-combination-container">
    <Header />

    <div class="claim-combination-container-wrap">
      <!-- 광고 -->
      <!-- <div class="claim-combination-advertisement">
        <div class="advertisement-inner-container">
          <button
            v-for="(item, idx) in advertisementList.results"
            :key="`${idx}`"
            class="advertisement-item"
            @click="goToAdvertisement(item)"
          >
            <img :src="item.image_url" alt="청구 조합기 광고" />
          </button>
        </div>
      </div> -->
      <div class="claim-combination-content-wrap">
        <!-- 청구 조합기 헤더 영역 -->
        <div class="claim-combination-header">
          <div class="claim-combination-menus">
            <button
              class="claim-combination-menu"
              :class="{
                'acitve-menu': isSelectedMenu(koConstantList.CHARGE_COMBINER),
              }"
              data-selector-menu
              @click="changeSelectedMenu(koConstantList.CHARGE_COMBINER)"
            >
              {{ koConstantList.CHARGE_COMBINER }}
              <div class="divider"></div>
            </button>
            <button
              class="claim-combination-menu"
              :class="{
                'acitve-menu': isSelectedMenu(koConstantList.CHARGE_BASKET),
              }"
              data-backet-menu
              @click="changeSelectedMenu(koConstantList.CHARGE_BASKET)"
            >
              {{ `${koConstantList.CHARGE_BASKET}` }}
              <span
                :class="{
                  'active-basket-count': isSelectedMenu(
                    koConstantList.CHARGE_BASKET,
                  ),
                }"
                >{{ basketCount }}</span
              >
            </button>
          </div>
          <div class="claim-combination-reference-date-container">
            <h2 class="reference-date-title">수가 기준 년도</h2>
            <v-select
              v-model="currentReferenceDate"
              :items="referenceDates"
              :item-text="item => formatedDate(item)"
              :item-value="item => item"
              class="claim-combination-reference-date"
              dense
              flat
              height="36"
              solo
            ></v-select>
          </div>
          <div class="claim-combination-condition-menus">
            <span class="date-based-on-medical-charge">{{
              `수가 기준 : ${changeDateFormat(currentReferenceDate)}`
            }}</span>
            <button
              v-if="isSelectMenu"
              class="condition-reset-button"
              @click="resetData"
            >
              조건 초기화
            </button>
            <button
              class="condition-search-button"
              :class="{
                'disabled-print-button':
                  !isSelectMenu && selectedList.length === 0,
              }"
              :disabled="!isSelectMenu && selectedList.length === 0"
              @click="
                () =>
                  isSelectMenu ? searchCombination() : navigateToPrintPage()
              "
            >
              {{ isSelectMenu ? '조합 찾기' : '프린트 하기' }}
            </button>
          </div>
        </div>
        <div v-if="isSelectMenu" class="claim-combination-body">
          <!-- 청구 조합기 선택지 영역 -->
          <!-- 1. 얼마에 맞춰 볼까요? -->
          <div class="claim-combination-inner-container">
            <ClaimCombinationTitle
              :props-object="conditionTitleList['copay']"
            />
            <div class="nonbenefit-pay-option-container">
              <v-switch
                v-model="isNonbenefit"
                inset
                :label="`비급여`"
                class="nonbenefit-toggle-button"
                :class="{ 'active-nonbenefit-toggle-button': isNonbenefit }"
              ></v-switch>

              <v-text-field
                v-model="fields.copay"
                type="number"
                outlined
                :height="44"
                hide-spin-buttons
                min="1"
                suffix="원"
                :error-messages="errors.copay"
                dense
                label="숫자
              입력"
                class="nonbenefit-pay-input"
              />
            </div>
          </div>
          <!-- 2. 진료 조건 선택 (필수) -->
          <div class="claim-combination-inner-container">
            <ClaimCombinationTitle
              :props-object="conditionTitleList['conditionOfCare']"
            />
            <div class="option-container ">
              <div class="option-list">
                <span class="option-label">병원 형태</span>
                <v-radio-group
                  ref="radio-group"
                  v-model="currentHopitalType"
                  row
                  mandatory
                  dense
                >
                  <v-radio
                    v-for="(type, idx) in hospitalTypes"
                    :key="`${type}_${idx}`"
                    :label="type"
                    :value="type"
                    :class="{
                      'active-label': currentHopitalType === type,
                    }"
                  />
                </v-radio-group>
              </div>
              <div class="option-list">
                <span class="option-label">초진/재진</span>
                <v-radio-group
                  ref="radio-group"
                  v-model="currrentPatientType"
                  row
                  mandatory
                  dense
                >
                  <v-radio
                    v-for="(type, idx) in patientTypes"
                    :key="`${type}_${idx}`"
                    :label="type"
                    :value="type"
                    :class="{
                      'active-label': currrentPatientType === type,
                    }"
                  />
                </v-radio-group>
              </div>
              <div class="option-list">
                <span class="option-label">진료 시간</span>
                <v-radio-group
                  ref="radio-group"
                  v-model="currentClinicHourType"
                  row
                  mandatory
                  dense
                >
                  <v-radio
                    v-for="(type, idx) in clinicHoursTypes"
                    :key="`${type}_${idx}`"
                    :label="type"
                    :value="type"
                    :class="{
                      'active-label': currentClinicHourType === type,
                    }"
                  />
                </v-radio-group>
              </div>
              <div v-if="patientAgeTypes.length" class="option-list">
                <span class="option-label">환자 나이</span>
                <v-radio-group
                  ref="radio-group"
                  v-model="currentPatientAgeType"
                  row
                  mandatory
                  dense
                >
                  <v-radio
                    v-for="(type, idx) in patientAgeTypes"
                    :key="`${type}_${idx}`"
                    :label="type"
                    :value="type"
                    :class="{
                      'active-label': currentPatientAgeType === type,
                    }"
                  />
                </v-radio-group>
              </div>
            </div>
          </div>
          <!-- 3. 경혈침술 종류 -->
          <div class="claim-combination-inner-container">
            <ClaimCombinationTitle
              :props-object="conditionTitleList['typeOfAcupuncture']"
            />
            <div class="option-container ">
              <div
                v-for="(list, ind) in typeOfAcupuncture"
                :key="`${list}-${ind}`"
                class="option-list"
              >
                <div>
                  <span class="option-label">{{ list.label }}</span>
                  <button
                    v-for="({ childrenLabel, isSelected },
                    index) in list.values"
                    :key="`${childrenLabel}-${index}`"
                    class="option-button"
                    :class="{ 'active-option-button': isSelected }"
                    @click="
                      () => {
                        toggleButtonActive(
                          'typeOfAcupuncture',
                          list.label,
                          childrenLabel,
                          isSelected,
                        );
                        toggleTypeOfAcupunctureList();
                      }
                    "
                  >
                    {{ childrenLabel }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- 4. 치료 종류 선택 -->
          <div class="claim-combination-inner-container">
            <ClaimCombinationTitle
              :props-object="conditionTitleList['typeOfTreatment']"
            />
            <div class="option-container ">
              <div
                v-for="(list, ind) in typeOfTreatment"
                :key="`${list}-${ind}`"
                class="option-list"
              >
                <div>
                  <span class="option-label">{{ list.label }}</span>
                  <button
                    v-for="({ childrenLabel, isSelected },
                    index) in list.values"
                    :key="`${childrenLabel}-${index}`"
                    class="option-button"
                    :class="{ 'active-option-button': isSelected }"
                    @click="
                      toggleButtonActive(
                        'typeOfTreatment',
                        list.label,
                        childrenLabel,
                        isSelected,
                      )
                    "
                  >
                    {{ childrenLabel }}
                  </button>

                  <div
                    v-if="isSelectedCupping(list)"
                    class="cupping-cup-container"
                  >
                    <span>부항컵 청구액</span>
                    <v-select
                      v-model="selectedCuppingCount"
                      :items="cuppingPayCountList"
                      solo
                      dense
                    ></v-select>
                    <v-text-field
                      v-model="fields.cuppingPay"
                      type="number"
                      hide-spin-buttons
                      :height="44"
                      min="1"
                      outlined
                      suffix="원"
                      dense
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 5. 원내 비치 한약제제 선택 -->
          <div class="claim-combination-inner-container">
            <ClaimCombinationTitle
              :props-object="conditionTitleList['herbalMedicineFormulation']"
            />

            <div class="herb-select-container">
              <div class="herb-input-container">
                <v-text-field
                  v-if="isCustomPrice"
                  v-model="fields.selfHerb"
                  type="number"
                  hide-spin-buttons
                  outlined
                  dense
                  min="1"
                  :height="44"
                  placeholder="숫자 입력"
                  suffix="원"
                  class="herb-formulation-input"
                >
                </v-text-field>
                <v-autocomplete
                  v-else
                  v-model="selectedHerbList"
                  :items="herbs"
                  dense
                  height="44"
                  :item-text="
                    item => `${item.herb_form_name} (${item.price}원)`
                  "
                  outlined
                  hide-details
                  return-object
                  label="한약제제 입력"
                  full-width
                  multiple
                  class="herb-formulation-input"
                  hide-selected
                  chips
                  deletable-chips
                  :search-input.sync="herbListInput"
                  @input="herbListInput = null"
                >
                </v-autocomplete>
                <button
                  class="herb-add-button"
                  @click="
                    () => (isCustomPrice ? registerSelfHerb() : registerHerb())
                  "
                >
                  등록
                </button>
              </div>
              <div class="herb-input-container">
                <v-switch
                  v-model="isCustomPrice"
                  inset
                  :label="`가격 직접 입력`"
                  class="price-toggle-button"
                  :class="{ 'active-price-toggle-button': isCustomPrice }"
                ></v-switch>
                <div class="selected-herb-button-container">
                  <button
                    v-for="(item, idx) in registeredHerbList"
                    :key="`${item.herb_form_name}-${idx}`"
                    class="selected-herb-button"
                    @click="removeRegisteredHerb(item)"
                  >
                    {{ `${item.herb_form_name} (${item.price}원)` }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- 6. 처방 일 수 -->
          <div class="claim-combination-inner-container">
            <ClaimCombinationTitle
              :props-object="conditionTitleList['numberOfPrescriptionDays']"
            />
            <v-text-field
              v-model="fields.prescriptionDays"
              type="number"
              outlined
              min="1"
              max="7"
              maxlength="1"
              dense
              :height="44"
              placeholder="숫자 입력"
              :error-messages="errors.prescriptionDays"
              suffix="일"
              class="claim-combination-input"
              :disabled="isDisabledPrescriptionDays"
            >
            </v-text-field>
          </div>
          <!-- 7. 검사 종류 선택 -->
          <div class="claim-combination-inner-container">
            <ClaimCombinationTitle
              :props-object="conditionTitleList['inspectionType']"
            />
            <div class="option-container inspection-type-container">
              <div class="option-list">
                <button
                  v-for="({ label, isSelected }, idx) in inspectionTypes"
                  :key="`${label}-${idx}`"
                  class="option-button"
                  :class="{ 'active-option-button': isSelected }"
                  @click="() => toggleInspectionType(label)"
                >
                  {{ label }}
                </button>
              </div>
            </div>
          </div>

          <div class="claim-combination-footer">
            <h2>메디스트림 청구 조합기 안내</h2>
            <p>
              · 진료를 보조할 목적으로 제작된 서비스입니다. 이 서비스에서
              제시하는 추천 청구 조합은 건강보험심사평가원의 청구 심사 결과와
              무관합니다.
            </p>
            <p>
              · 이 서비스에서 추천하는 청구 조합은 사용자가 설정한 청구 조건과
              본인부담금에 따라 계산된 결과이며, 특정 청구 형태를 조장하기 위한
              의도가 없습니다.
            </p>
          </div>
        </div>
        <div v-else>
          <!-- 청구 바구니 -->
          <ClaimCombinationBasketVue
            :is-select-menu="isSelectMenu"
            :combination-list="combinationList"
            :selected-list.sync="selectedList"
            :get-combination="getCombination"
          />
        </div>
      </div>
    </div>
    <!-- 청구 바구니 -->
    <SearchResult
      :search-result.sync="searchResultProps"
      :current-menu.sync="currentMenu"
      :reference-date="currentReferenceDate"
    />
    <!-- 로더 -->
    <general-spinner v-if="isFetchingData" class="general-spinner" />
  </div>
</template>

<script>
import { getDay, format, getYear } from 'date-fns';
import ClaimCombinationTitle from '@/components/ClaimCombination/ClaimCombinationTitle.vue';
import SearchResult from '@/components/ClaimCombination/SearchResult.vue';
import GeneralSpinner from '@/components/GeneralSpinner';
import ClaimCombinationBasketVue from '@/components/ClaimCombination/ClaimCombinationBasket.vue';
// eslint-disable-next-line max-len
// import ClaimCombinationResultPrintVue from '@/components/ClaimCombination/ClaimCombinationResultPrint.vue';
import Header from '@/components/Header.vue';
import _ from 'lodash';
import { combinationApi, advertisementApi } from '@/services/apis';
import { mapState } from 'vuex';
import { onGASearchCount } from '../utils/GATag';
// eslint-disable-next-line max-len
// MARK : https://stackoverflow.com/questions/35604987/is-there-a-proper-way-of-resetting-a-components-initial-data-in-vuejs
function getInitialData() {
  return {
    // 광고
    advertisementList: [],
    // 청구 조합기
    currentHopitalType: '',
    currrentPatientType: '',
    currentClinicHourType: '',
    currentPatientAgeType: '',
    hospitalTypes: ['한의원', '한방병원 (동)', '한방병원 (읍면)'],
    patientTypes: ['초진', '재진'],
    clinicHoursTypes: ['평일 주간', '토요일 9~13시', '야간/공휴일'],
    patientAgeTypes: ['65세 미만', '65세 이상'],
    selectedHerbList: null,
    registeredHerbList: [],
    herbListInput: '',
    selectedCuppingCount: 0,
    doubleSelectedList: [],
    cuppingPayCountList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    currentMenu: '청구 조합기',
    menus: ['청구 조합기', '청구 바구니'],
    currentHerb: '',
    herbs: [],

    isCustomPrice: false,
    isNonbenefit: false,
    conditionTitleList: {
      copay: {
        title: '본부금을 얼마에 맞춰 볼까요?',
        description: '비급여 선택 시, 조합 결과에 ',
        subDescription: '비급여 금액을 계산해 줍니다.',

        sequense: 1,
        isRequired: true,
      },
      conditionOfCare: {
        title: '진료 조건 선택',
        description: '필수 선택입니다.',
        subDescription: '진료 조건을 선택해 주세요.',
        sequense: 2,
        isRequired: true,
      },
      typeOfAcupuncture: {
        title: '침술 종류 선택',
        description: '원하는 항목을 선택할 수 있습니다.',
        subDescription: '침술 종류를 선택해 주세요.',
        sequense: 3,
      },
      typeOfTreatment: {
        title: '치료 종류 선택',
        description: '원하는 항목을 선택할 수 있습니다.',
        subDescription: '치료 종류를 선택해 주세요.',
        sequense: 4,
      },

      herbalMedicineFormulation: {
        title: '원내 비치 한약제제 선택',
        description: '원하시는 한약제제를 입력해 주세요.',
        sequense: 5,
      },
      numberOfPrescriptionDays: {
        title: '처방 일 수',
        description: '최대 7일까지 입력 가능합니다.',
        sequense: 6,
      },
      inspectionType: {
        title: '검사 종류 선택',
        description: '원하는 항목을 선택할 수 있습니다.',
        subDescription: '검사 종류를 선택해 주세요.',
        sequense: 7,
      },
    },
    typeOfAcupuncture: [
      {
        label: '경혈 침술',
        values: [
          { childrenLabel: '1부위', isSelected: true },
          { childrenLabel: '2부위', isSelected: true },
        ],
      },
      {
        label: '부가 침술',
        values: [
          { childrenLabel: '자락/도침/산침', isSelected: false },
          { childrenLabel: '사암/오행/체질', isSelected: false },
          { childrenLabel: '화침/온침', isSelected: false },
        ],
      },

      {
        label: '특수 침술',
        values: [
          { childrenLabel: '투자', isSelected: false },
          { childrenLabel: '척추', isSelected: false },
          { childrenLabel: '관절', isSelected: false },
          { childrenLabel: '복강', isSelected: false },
          { childrenLabel: '비강', isSelected: false },
          { childrenLabel: '안와', isSelected: false },
        ],
      },
      {
        label: '침전기자극술',
        values: [
          { childrenLabel: '포함', isSelected: false },
          { childrenLabel: '제외', isSelected: true },
        ],
      },
    ],
    typeOfTreatment: [
      {
        label: '구술',
        values: [
          { childrenLabel: '기기구술', isSelected: false },
          { childrenLabel: '반흔구', isSelected: false },
          { childrenLabel: '간접 애주구', isSelected: false },
          { childrenLabel: '직접 애주구', isSelected: false },
        ],
      },
      {
        label: '건부항술',
        values: [
          { childrenLabel: '유관법', isSelected: false },
          { childrenLabel: '섬관법', isSelected: false },
          { childrenLabel: '주관법', isSelected: false },
        ],
      },
      {
        label: '자락관법',
        values: [
          { childrenLabel: '자락관법', isSelected: false },
          { childrenLabel: '자락관법 (2부위)', isSelected: false },
        ],
      },

      {
        label: '물리요법',
        values: [
          { childrenLabel: '경피적외선조사요법', isSelected: false },
          { childrenLabel: '경피경근온열요법', isSelected: false },
          { childrenLabel: '경피경근한냉요법', isSelected: false },
        ],
      },
      {
        label: '추나요법',
        values: [
          { childrenLabel: '단순 추나', isSelected: false },
          {
            childrenLabel: '복잡 추나(본인 부담(50%))',
            isSelected: false,
          },
          {
            childrenLabel: '복잡 추나(본인 부담(80%))',
            isSelected: false,
          },
        ],
      },
      {
        label: '변증기술료',
        values: [
          { childrenLabel: '포함', isSelected: false },
          { childrenLabel: '제외', isSelected: true },
        ],
      },
    ],

    inspectionTypes: [
      { label: '맥전도', isSelected: false },
      { label: '3D맥영상', isSelected: false },
      { label: '양도락', isSelected: false },
      { label: '경락기능', isSelected: false },
      { label: '양명경', isSelected: false },
      { label: '수양명경', isSelected: false },
    ],
    // TODO: 백엔드 API가 있습니다.. 시간이 없어서 작업하지못한 절 용서하세요 ..
    referenceDates: [
      new Date('2022-01-01'),
      new Date('2023-01-01'),
      new Date('2024-01-01'),
      new Date('2025-01-01'),
      new Date('2026-01-01'),
    ],
    currentReferenceDate: new Date('2026-01-01'),
    numberCode: {
      한의원: '00',
      '한방병원 (동)': '01',
      '한방병원 (읍면)': '01',
      초진: '101',
      재진: '102',
      '평일 주간': null,
      '토요일 9~13시': '03',
      '야간/공휴일': '01',
      '1부위': '40011',
      '2부위': '40012',
      '자락/도침/산침': '2',
      '사암/오행/체질': '4',
      '화침/온침': '6',
      투자: '40080',
      척추: '40070',
      관절: '40060',
      복강: '40050',
      비강: '40040',
      안와: '40030',
      침전기자극술: '40091',
      기기구술: '40307',
      반흔구: '40305',
      '간접 애주구': '40306',
      '직접 애주구': '40304',
      유관법: '40321',
      섬관법: '40322',
      주관법: '40323',
      자락관법: '40312',
      '자락관법 (2부위)': '40313',
      경피적외선조사요법: '40701',
      경피경근온열요법: '40700',
      경피경근한냉요법: '40702',
      '단순 추나': '40710',
      '복잡 추나(본인 부담(50%))': '40720',
      '복잡 추나(본인 부담(80%))': '40721',
      변증기술료: '40400',
      '처방일수 1': '30010',
      '처방일수 2': '30020',
      '처방일수 3': '30030',
      '처방일수 4': '30040',
      '처방일수 5': '30050',
      '처방일수 6': '30060',
      '처방일수 7': '30070',
      맥전도: '20020',
      '3D맥영상': '20023',
      양도락: '20010',
      경락기능: '20030',
      양명경: '20031',
      수양명경: '20032',
    },
    // MARK: text-field
    errors: {
      copay: '',
      herb: '',
      selfHerb: '',
      prescriptionDays: '',
    },
    fields: {
      copay: null,
      cuppingPay: 124,
      selfHerb: null,
      prescriptionDays: null,
    },

    // MARK: SearchResult.vue props
    combinationList: [],
    isFetchingData: false,
    selectedList: [],
    searchResultProps: {
      isOpenSearchResultModal: false,
      searchData: [],
      searchResultCount: 0,
    },
  };
}
export default {
  name: 'claim-combination',
  components: {
    Header,
    ClaimCombinationTitle,
    SearchResult,
    GeneralSpinner,
    ClaimCombinationBasketVue,
  },

  data() {
    return getInitialData();
  },

  computed: {
    basketCount() {
      return this.combinationList.length >= 99
        ? '99+'
        : this.combinationList.length;
    },
    koConstantList() {
      return {
        CHARGE_COMBINER: '청구 조합기',
        CHARGE_BASKET: '청구 바구니',
      };
    },
    isDisabledPrescriptionDays() {
      return this.registeredHerbList.length === 0;
    },
    isSelectMenu() {
      return this.currentMenu === this.koConstantList.CHARGE_COMBINER;
    },
    isNotSeletedAcupointAcupuncture() {
      const [acupointAcupucture] = this.typeOfAcupuncture;
      return acupointAcupucture.values.every(({ isSelected }) => !isSelected);
    },
    ...mapState(['$user']),
  },

  watch: {
    searchResultProps: {
      handler({ isOpenSearchResultModal }) {
        if (isOpenSearchResultModal) {
          document.querySelector('html').style.overflowY = 'hidden';
          return;
        }
        document.querySelector('html').style.overflowY = null;
      },
      deep: true,
      immediate: true,
    },

    registeredHerbList(list) {
      if (list.length && this.fields.prescriptionDays === null) {
        this.fields.prescriptionDays = 1;
        return;
      }
      if (list.length === 0) {
        this.fields.prescriptionDays = null;
      }
    },
    currentHopitalType(type) {
      if (type !== '한의원') {
        this.clinicHoursTypes = ['평일 주간', '야간/공휴일'];
        this.patientAgeTypes = [];
        this.currentPatientAgeType = null;
        return;
      }
      this.clinicHoursTypes = ['평일 주간', '토요일 9~13시', '야간/공휴일'];
      this.patientAgeTypes = ['65세 미만', '65세 이상'];
    },
    fields: {
      handler() {
        if (this.fields.copay) {
          this.errors = {
            ...this.errors,
            copay: '',
          };
        }
        if (this.fields.prescriptionDays) {
          this.errors = {
            ...this.errors,
            prescriptionDays: '',
          };
        }
      },
      deep: true,
    },
    currentMenu: {
      handler() {
        this.getCombination();
      },
    },
    currentReferenceDate: {
      handler() {
        this.getCombination();
      },
    },
  },

  created() {
    this.localStorageToMembersDB();
  },
  mounted() {
    const hasReferenceDate = this.$route.query.referenceDate;
    if (hasReferenceDate) {
      this.currentReferenceDate = new Date(this.$route.query.referenceDate);
    }
    this.getHerbs();
    this.getCombination();
    // this.getAdvertisement();
  },
  methods: {
    localStorageToMembersDB() {
      const isUploaded = JSON.parse(
        localStorage.getItem('isLocalToDBUploaded'),
      );
      if (isUploaded) {
        // MARK: 한번 업로드 한 경우 다시 업로드 하지 않음
        return;
      }
      //TODO: 로컬 스토리지에 있는 조합을 MEMBERS DB로 이관 추후 로직 제거
      const localCombinationList = [
        JSON.parse(localStorage.getItem('2022-combinationList')),
        JSON.parse(localStorage.getItem('2023-combinationList')),
      ];
      const byYearPayloadData = localCombinationList.map((list, idx) => {
        if (list === null) {
          return;
        }
        const dates = {
          0: '2022-01-01',
          1: '2023-01-01',
        };

        return list.map(({ id, ...rest }) => {
          return {
            referenceDate: dates[idx],
            ...rest,
          };
        });
      });
      byYearPayloadData.forEach(payload => {
        // MARK : localStorage에 해당 년도의 조합이 있는 경우에만 POST 요청을 보낸다.
        if (payload) {
          this.postCombination(payload);
        }
      });
      localStorage.setItem('isLocalToDBUploaded', JSON.stringify(true));
    },
    formatedDate(date) {
      return format(date, 'yyyy년');
    },
    goToAdvertisement(item) {
      window.open(item.redirect_uri, '_blank');
    },
    navigateToPrintPage() {
      const referenceDate = getYear(this.currentReferenceDate);
      localStorage.setItem('printList', JSON.stringify(this.selectedList));
      this.$router.push({
        path: `/claim-combination-result-print?referenceDate=${referenceDate}`,
      });
    },
    isSelectedCupping(list) {
      if (list.label === '자락관법') {
        return (
          list.values.some(({ isSelected }) => isSelected) ||
          this.typeOfTreatment[1].values.some(({ isSelected }) => isSelected)
        );
      }
      return false;
    },
    async getAdvertisement() {
      try {
        const { data, status } = await advertisementApi.getAdvertisement();
        if (status === 200) {
          this.advertisementList = data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getHerbs() {
      try {
        const { data, status } = await combinationApi.getHerbs();
        if (status === 200) {
          this.herbs = data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getCombination() {
      try {
        const referenceDate = format(this.currentReferenceDate, 'yyyy-MM-dd');
        const { data, status } = await combinationApi.getCombination(
          referenceDate,
        );

        if (status === 200) {
          this.combinationList = data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async postCombination(body) {
      try {
        const { status } = await combinationApi.postCombination(body);
        if (status === 200 || status === 204) {
          console.log('[local to DB POST success]', status);
          // this.getCombination();
        }
      } catch (e) {
        console.log(e);
      }
    },
    resetData() {
      const data = getInitialData();
      const { combinationList, ...rest } = getInitialData();
      Object.keys(rest).forEach(key => (this[key] = data[key]));
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    searchCombination: _.debounce(async function() {
      try {
        if (!this.fields.copay) {
          this.errors.copay = '필수 입력 항목입니다.';
          this.scrollToTop();
          return;
        }
        if (this.registeredHerbList.length && !this.fields.prescriptionDays) {
          this.errors.prescriptionDays = '필수 입력 항목입니다.';
          return;
        }

        this.isFetchingData = true;
        const convertToCode = label => this.numberCode[label];
        const returnSelectedList = list => {
          if (list === undefined) {
            return [];
          }
          const { values } = list;
          return values
            .filter(({ isSelected }) => isSelected)
            .map(({ childrenLabel }) => convertToCode(childrenLabel));
        };

        const returnAcupuntureElectrical = (label, list) => {
          if (list === undefined) {
            return null;
          }
          const selectedList = list.values.filter(
            ({ isSelected }) => isSelected,
          );
          if (selectedList.length) {
            const [selectItem] = selectedList;
            return selectItem.childrenLabel === '포함'
              ? convertToCode(label)
              : null;
          }
          return null;
        };
        const returnClaimCombinationCode = () => {
          const day = this.fields.prescriptionDays;
          const koClaimCombinationLookupTable = {
            1: '처방일수 1',
            2: '처방일수 2',
            3: '처방일수 3',
            4: '처방일수 4',
            5: '처방일수 5',
            6: '처방일수 6',
            7: '처방일수 7',
          };
          return koClaimCombinationLookupTable[day];
        };

        const acupointAcupucture = this.typeOfAcupuncture.find(
          v => v.label === '경혈 침술',
        );
        const subAcupointAcupucture = this.typeOfAcupuncture.find(
          v => v.label === '부가 침술',
        );
        const specialAcupuncture = this.typeOfAcupuncture.find(
          v => v.label === '특수 침술',
        );
        const electroacupunture = this.typeOfAcupuncture.find(
          v => v.label === '침전기자극술',
        );

        const [
          moxibustion,
          cupping,
          wetCupping,
          physicalTherapy,
          chunaTherapy,
          dialecticSkillFee,
        ] = this.typeOfTreatment;
        const payload = {
          hospitalForm: this.numberCode[this.currentHopitalType],
          patientForm: this.numberCode[this.currrentPatientType],
          clinicHours: this.numberCode[this.currentClinicHourType],
          isFarm:
            this.currentHopitalType === '한의원'
              ? null
              : this.currentHopitalType === '한방병원 (읍면)',
          isSenior:
            this.currentHopitalType === '한의원'
              ? this.currentPatientAgeType === '65세 이상'
              : null,
          acupunctureGeneral: returnSelectedList(acupointAcupucture),
          acupunctureAdditional: returnSelectedList(subAcupointAcupucture),
          acupunctureSpecial: returnSelectedList(specialAcupuncture),
          acupunctureElectrical: returnAcupuntureElectrical(
            '침전기자극술',
            electroacupunture,
          ),
          moxibustion: returnSelectedList(moxibustion),
          cupping: [
            ...returnSelectedList(cupping),
            ...returnSelectedList(wetCupping),
          ],
          cuppingCup:
            cupping.values.some(({ isSelected }) => isSelected) ||
            wetCupping.values.some(({ isSelected }) => isSelected)
              ? {
                  count: this.selectedCuppingCount,
                  pay: this.fields.cuppingPay,
                }
              : { count: null, pay: null },
          physicalTherapy: returnSelectedList(physicalTherapy),
          chunaTherapy: returnSelectedList(chunaTherapy),
          dialecticSkillFee: returnAcupuntureElectrical(
            '변증기술료',
            dialecticSkillFee,
          ),
          isNonbenefit: this.isNonbenefit,
          copay: Number(this.fields.copay),
          herb: this.registeredHerbList
            .filter(({ herb_form_name }) => herb_form_name !== '직접 입력')
            .map(({ id }) => id),
          selfHerb: this.registeredHerbList
            .filter(({ herb_form_name }) => herb_form_name === '직접 입력')
            .map(({ price }) => Number(price)),
          prescriptionDays: convertToCode(returnClaimCombinationCode()) ?? null,
          inspectionType: this.inspectionTypes
            .filter(({ isSelected }) => isSelected)
            .map(({ label }) => convertToCode(label)),
        };
        const referenceDate = format(this.currentReferenceDate, 'yyyy-MM-dd');
        const { data, status } = await combinationApi.searchCombination(
          referenceDate,
          payload,
        );

        if (!data || !status) {
          return;
        }
        if (status === 200) {
          this.isFetchingData = false;
          onGASearchCount();
          this.searchResultProps.isOpenSearchResultModal = true;
          this.searchResultProps.searchResultCount = data.length;
          this.searchResultProps.searchData = data.map(v => {
            // MARK: - 객체의 값을 모아 uniqId 생성
            const listId = Object.values(v)
              .map(v => {
                const isObject = v !== null && typeof v === 'object';
                const isBoolean = typeof v === 'boolean';
                if (isObject) {
                  return Object.values(v).join('');
                }
                if (isBoolean) {
                  return v ? 1 : 0;
                }
                return v;
              })
              .join('');

            return {
              ...v,
              id: listId,
            };
          });
        }
      } catch (error) {
        console.error(error);
      }
    }, 300),

    registerHerb() {
      const maxSelectLength = 5;
      this.registeredHerbList = [
        ...this.registeredHerbList,
        ...this.selectedHerbList,
      ];
      const isFull = this.registeredHerbList.length >= maxSelectLength;
      if (isFull) {
        this.registeredHerbList = this.registeredHerbList.slice(
          0,
          maxSelectLength,
        );
      }

      this.herbListInput = null;
      this.selectedHerbList = [];
      this.herbs = this.herbs.filter(herbInfo => {
        const registeredHerbId = this.registeredHerbList.map(v => v.id);
        return !registeredHerbId.some(id => id === herbInfo.id);
      });
    },
    registerSelfHerb() {
      const maxSelectLength = 5;

      const hasFieldValue = this.fields.selfHerb;
      const randomId = String(Math.floor(Math.random() * 1000000)).padStart(
        6,
        '0',
      );
      if (hasFieldValue) {
        const hasPrice = this.registeredHerbList.some(
          v => v.price === this.fields.selfHerb,
        );
        if (hasPrice) {
          return;
        }
        this.registeredHerbList.push({
          id: randomId,
          herb_form_name: '직접 입력',
          price: this.fields.selfHerb,
        });
        const isFull = this.registeredHerbList.length >= maxSelectLength;

        if (isFull) {
          this.registeredHerbList = this.registeredHerbList.slice(
            0,
            maxSelectLength,
          );
        }
        this.fields.selfHerb = '';
      }
    },
    removeRegisteredHerb(item) {
      const { id, herb_form_name } = item;
      if (herb_form_name !== '직접 입력') {
        this.herbs = [
          ...this.herbs,
          ...this.registeredHerbList.filter(herbInfo => herbInfo.id === id),
        ];
      }

      this.registeredHerbList = this.registeredHerbList.filter(
        herbInfo => herbInfo.id !== id,
      );
    },
    changeDateFormat(date) {
      const formatedDate = format(new Date(date), 'yyyy-MM-dd');
      const dayIndex = getDay(new Date(date));
      const day = ['일', '월', '화', '수', '목', '금', '토'][dayIndex];
      return `${formatedDate} (${day})`;
    },
    changeSubAccupointAcupunctureList() {
      // MARK 경혈 침술 미선택 시 부가 침술 리스트 제거
      const [acupointAcupucture, ...rest] = this.typeOfAcupuncture;
      const isNotSelectedAcupointAcupucture = acupointAcupucture.values.every(
        ({ isSelected }) => !isSelected,
      );
      const hasSubAcupointAcupucture = this.typeOfAcupuncture.some(
        ({ label }) => label === '부가 침술',
      );
      if (isNotSelectedAcupointAcupucture) {
        const filteredSubAcupointAcupucture = this.typeOfAcupuncture.filter(
          ({ label }) => label !== '부가 침술',
        );
        this.typeOfAcupuncture = filteredSubAcupointAcupucture;
        return;
      }

      if (hasSubAcupointAcupucture) {
        return;
      }

      this.typeOfAcupuncture = [
        acupointAcupucture,
        {
          label: '부가 침술',
          values: [
            { childrenLabel: '자락/도침/산침', isSelected: false },
            { childrenLabel: '사암/오행/체질', isSelected: false },
            { childrenLabel: '화침/온침', isSelected: false },
          ],
        },
        ...rest,
      ];
    },

    changeDoubleSelectList(key, label, childrenLabel) {
      // MARK: 특수 침술, 구술, 건부항, 물리요법은  2개 이상 선택 불가
      const hasSameLabel = this.doubleSelectedList.some(
        label => label === childrenLabel,
      );
      const isExceededMaxNumber = this.doubleSelectedList.length >= 2;
      const toggleSelected = () => {
        this[key] = this[key].map(item => {
          const isSameLabel = item.label === label;
          if (isSameLabel) {
            return {
              ...item,
              values: item.values.map(value => {
                const hasLabel = this.doubleSelectedList.some(
                  label => label === value.childrenLabel,
                );
                return {
                  ...value,
                  isSelected: hasLabel,
                };
              }),
            };
          }
          return item;
        });
      };

      if (hasSameLabel) {
        this.doubleSelectedList = this.doubleSelectedList.filter(
          label => label !== childrenLabel,
        );
        toggleSelected();
        return;
      }
      if (isExceededMaxNumber) {
        const [firstSelect, ...rest] = this.doubleSelectedList;
        this.doubleSelectedList = [...rest, childrenLabel];
        toggleSelected();
        return;
      }
      this.doubleSelectedList.push(childrenLabel);
      toggleSelected();
    },

    changeElectroacupuntureList() {
      // MARK: 경혈 침술, 특수 침술, 부가 침술 미선택 시 침전기 자극술 리스트 제거
      const isOpenElectroacupuntureList = this.typeOfAcupuncture
        .filter(({ label }) => label !== '침전기자극술')
        .some(({ values }) => values.some(({ isSelected }) => isSelected));

      const hasElectroacupuntureList = this.typeOfAcupuncture.some(
        ({ label }) => label === '침전기자극술',
      );
      if (isOpenElectroacupuntureList) {
        if (hasElectroacupuntureList) {
          return;
        }
        this.typeOfAcupuncture = [
          ...this.typeOfAcupuncture,
          {
            label: '침전기자극술',
            values: [
              { childrenLabel: '포함', isSelected: false },
              { childrenLabel: '제외', isSelected: true },
            ],
          },
        ];
        return;
      }
      this.typeOfAcupuncture = this.typeOfAcupuncture.filter(
        ({ label }) => label !== '침전기자극술',
      );
    },
    toggleTypeOfAcupunctureList() {
      this.changeSubAccupointAcupunctureList();
      this.changeElectroacupuntureList();
    },
    changeButtonActive(key, label, childrenLabel) {
      this[key] = this[key].map(condition => {
        const isNotSameLabel = condition.label !== label;
        if (isNotSameLabel) {
          return condition;
        }

        const returnValues = () => {
          return condition.values.map(value => {
            const isSameChildrenLabel = value.childrenLabel === childrenLabel;
            // 변증기술료나 침전기자극술읜 경우 하나만 선택 가능
            if (label === '변증기술료' || label === '침전기자극술') {
              return {
                ...value,
                isSelected: isSameChildrenLabel ? true : false,
              };
            }
            return {
              ...value,
              isSelected: isSameChildrenLabel ? !value.isSelected : false,
            };
          });
        };
        return {
          ...condition,
          values: returnValues(),
        };
      });
    },
    toggleButtonActive(key, label, childrenLabel, isSelected) {
      const isSpecialAcupuncture =
        label === '특수 침술' ||
        label === '구술' ||
        label === '건부항술' ||
        label === '물리요법';
      if (isSpecialAcupuncture) {
        this.changeDoubleSelectList(key, label, childrenLabel);
        return;
      }

      const isNotMultipleButton =
        label === '침전기자극술' ||
        label === '변증기술료' ||
        label === '자락관법' ||
        label === '추나요법' ||
        label === '부가 침술';

      if (isNotMultipleButton) {
        this.changeButtonActive(key, label, childrenLabel);
        return;
      }

      this[key] = this[key].map(condition => {
        const isNotSameLabel = condition.label !== label;
        if (isNotSameLabel) {
          return condition;
        }
        return {
          ...condition,
          values: condition.values.map(value => {
            if (value.childrenLabel !== childrenLabel) {
              return value;
            }
            return {
              ...value,
              isSelected: !isSelected,
            };
          }),
        };
      });
    },

    toggleInspectionType(label) {
      // MARK : 검사 유형은 1개 이상 선택 불가
      // 이미 1개 이상 선택한 경우 먼저 선택한 항목을 해제하고 선택한 항목을 추가
      const isExceededMaxNumber =
        this.inspectionTypes.filter(({ isSelected }) => isSelected).length >= 1;

      const clearActive = (type, label) => {
        if (type.label !== label) {
          return type;
        }
        return {
          ...type,
          isSelected: false,
        };
      };
      if (isExceededMaxNumber) {
        // 현재 선택한 라벨과 같은 라벨이 있는 경우 해제
        const isSameLabel = this.inspectionTypes.some(
          ({ label: currentLabel, isSelected }) =>
            currentLabel === label && isSelected,
        );
        if (isSameLabel) {
          this.inspectionTypes = this.inspectionTypes.map(type =>
            clearActive(type, label),
          );
          return;
        }

        const [firstSelect] = this.inspectionTypes.filter(
          ({ isSelected }) => isSelected,
        );

        this.inspectionTypes = this.inspectionTypes.map(type =>
          clearActive(type, firstSelect.label),
        );
      }

      this.inspectionTypes = this.inspectionTypes.map(type => {
        if (type.label !== label) {
          return type;
        }
        return {
          ...type,
          isSelected: !type.isSelected,
        };
      });
    },
    isSelectedMenu(menu) {
      return this.currentMenu === menu;
    },
    changeSelectedMenu(menu) {
      this.currentMenu = menu;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .general-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.claim-combination-container {
  max-width: 62.5rem;
  margin: 0 auto;
  margin-bottom: 4.875rem;
  // MARK : drag & copy 막기
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  .claim-combination-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.25rem;
  }
  .claim-combination-container-wrap {
    display: flex;
    margin-top: 1.75rem;
    //MARK 광고 삽입 후 제거
    justify-content: center;
  }
  .claim-combination-content-wrap {
    width: 51.5rem;
  }
  .claim-combination-reference-date-container {
    display: flex;
    align-items: center;
    .reference-date-title {
      font-size: 0.875rem;
      margin-right: 0.625rem;
      color: #6b6d73;
    }
    .claim-combination-reference-date {
      width: 7.125rem;
      ::v-deep .v-input__slot {
        background-color: #fff !important;
      }
      ::v-deep .v-select__selection {
        font-size: 0.875rem;
      }
    }
  }
  .claim-combination-body {
    margin-bottom: 4.875rem;
  }
  .claim-combination-menus {
    display: flex;
    align-items: center;

    & > button {
      font-size: 1.25rem;
      font-weight: 700;
      color: #b5b7bf;
      align-items: center;
      display: flex;
      white-space: nowrap;
      & > span {
        margin-left: 0.25rem;
      }
    }
    & > button:hover {
      color: #6b6d73;
      transition: 150ms ease-out;
      transform: translateY(0.25rem);
    }
    .divider {
      width: 0.0625rem;
      height: 1.375rem;
      margin: 0 1rem;
      background: #d4d7df;
    }
    .acitve-menu {
      color: #000 !important;
      transition: 150ms ease-out;
      transform: translateY(0) !important;
    }
    .active-basket-count {
      color: #1d77ff;
    }
  }
  .claim-combination-condition-menus {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 4.5rem;
    z-index: 10;
    background-color: #fff;
    margin: 0 auto;
    padding: 0 11.5rem;
    .date-based-on-medical-charge {
      font-size: 0.8125rem;
      color: #b5b7bf;
      margin-right: 0.625rem;
    }
    & > button {
      width: 8.75rem;
      height: 3.25rem;
      font-weight: 700;
      border-radius: 0.375rem;
    }
    .condition-reset-button {
      background-color: #fff;
      border: 0.0625rem solid #d4d7df;
      color: #1d77ff;
      margin-right: 0.5rem;
    }
    .condition-search-button {
      background-color: #1d77ff;
      border: 0.0625rem solid #1d77ff;
      color: #fff;
    }
    .disabled-print-button {
      background-color: #e1e4ec;
      border: 0.0625rem solid #d4d7df;
      color: #fff;
    }
  }
  .claim-combination-footer {
    margin-left: 1rem;
    h2 {
      font-size: 0.8125rem;
      margin-top: 1.5rem;
      margin-bottom: 0.25rem;
    }
    p {
      font-size: 0.8125rem;
      color: #515257;
      margin-bottom: 0;
    }
  }
  .claim-combination-advertisement {
    margin-right: 1.25rem;
    width: 9.75rem;
    .advertisement-item {
      width: 9.75rem;
      height: 15.625rem;
      border-radius: 4px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 0.25rem;
        transition: transform 0.3s ease-in-out;
        transform: scale(1);
        display: block;
      }
      img:hover {
        transition: transform 0.3s ease-in-out;
        transform: scale(1.03);
      }
    }
  }
}
.claim-combination-inner-container {
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 0.375rem;
  padding: 2rem 1.5rem;
  margin-bottom: 0.625rem;

  .nonbenefit-pay-option-container {
    display: flex;
    flex: 1;
    align-items: center;
  }
  .herb-select-container {
    ::v-deep .v-input__slot {
      padding: 0.5rem !important;
    }
    ::v-deep .v-select__selections {
      max-height: 28.5rem;
      height: 3.5rem;
      // overflow: scroll;
    }
    .herb-input-container {
      display: flex;
      align-items: center;
      .selected-herb-button-container {
        width: 32.875rem;
        height: 3.5rem;
        margin-top: 0.5rem;
        margin-left: 3.25rem;
      }
      .selected-herb-button {
        padding: 0.375rem;
        background: #fbfcff;
        border: 0.0625rem solid #d4d7df;
        border-radius: 0.125rem;
        margin-right: 0.375rem;
        margin-bottom: 0.375rem;
        font-size: 0.75rem;
      }
      .selected-herb-button::after {
        content: '\F0159';
        display: inline-block;
        font: normal normal normal 1.5rem/1 'Material Design Icons';
        font-size: inherit;
        text-rendering: auto;
        line-height: inherit;
        -webkit-font-smoothing: antialiased;
      }
    }
    .herb-formulation-input {
      max-width: 27.125rem;
      margin-left: 3.25rem;
      font-size: 0.8125rem;
      ::v-deep .v-input__control {
        background: #f1f3f8;
        border-radius: 0.375rem;
        border: none;
      }
      ::v-deep label,
      ::v-deep .v-input__icon {
        position: absolute;
        top: 6px;
        right: 0;
      }
      ::v-deep .v-select__selections {
        height: 2.75rem !important;
        padding: 0.5rem 0;
      }
      ::v-deep label,
      ::v-deep input::placeholder {
        color: #b5b7bf !important;
      }
    }

    .herb-add-button {
      min-width: 3.625rem;
      height: 2.5rem;
      border-radius: 0.375rem;
      padding: 0.75rem 0.875rem;
      background-color: #000;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 0.625rem;
    }
    ::v-deep .v-chip {
      margin-bottom: 0.5rem;
      color: #1a1b1e;
      font-size: 0.75rem;
      background: #fbfcff;
      border: 0.0625rem solid #d4d7df;
      border-radius: 0.125rem;
    }
    ::v-deep .price-toggle-button {
      position: absolute;
      top: 6.625rem;
      left: -1.25rem;
    }
  }
  .claim-combination-input {
    max-width: 28.625rem;
    margin-left: 3.25rem;
    ::v-deep .v-messages {
      display: inline-block !important;
    }
    ::v-deep .v-text-field__details {
      position: absolute;
      bottom: -2.125rem;
      margin-top: 0.75rem !important;
      display: inline-block !important;
    }
    ::v-deep label,
    ::v-deep input::placeholder {
      color: #b5b7bf !important;
    }
  }
  .claim-combination-input,
  .herb-formulation-input {
    ::v-deep .v-messages {
      display: inline-block !important;
    }
    ::v-deep .v-text-field__details {
      margin-top: 0.75rem !important;
      display: inline-block !important;
    }
  }

  .inspection-type-container {
    margin-left: 1.75rem;
  }
  .option-container {
    display: flex;
    flex-direction: column;
    flex: 1;

    .option-list {
      display: flex;
      align-items: center;
      flex-direction: row;
      .active-label {
        font-weight: 700;
      }
    }
    .option-list:not(:last-child) {
      margin-bottom: 2rem;
    }
    .option-label {
      display: inline-block;
      font-size: 0.8125rem;
      color: #b5b7bf;
      min-width: 4.375rem !important;
      margin-right: 0.625rem;
    }
    .option-button {
      height: 2.25rem;
      font-weight: 700;
      padding: 0 0.875rem;
      color: #b5b7bf;
      font-size: 0.8125rem;
      background: #f1f3f8;
      border: 0.0625rem solid #f1f3f8;
      border-radius: 0.375rem;
    }
    .option-button:not(:last-child) {
      margin-right: 0.625rem;
    }
    .active-option-button {
      color: #1d77ff;
      background-color: #fff;
      border: 0.0625rem solid #1d77ff;
    }
    .cupping-cup-container {
      display: flex;
      margin-left: 5rem;
      margin-top: 0.625rem;
      width: 16.875rem;
      align-items: center;
      span {
        font-size: 0.8125rem;
        color: #515257;
        margin-right: 0.3125rem;
      }
    }
  }
}
// vuetify css override
::v-deep .v-input--radio-group--row {
  margin: 0;
  padding: 0;
}

::v-deep .v-input__slot {
  margin: 0 !important;
}

.cupping-cup-container {
  position: relative;
  ::v-deep
    .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
    > .v-input__control
    > .v-input__slot {
    margin: 0 !important;
    box-shadow: none;
    width: 5rem;
    height: 2.75rem;
    background: #f1f3f8;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    margin-right: 0.3125rem !important;
  }
}
::v-deep
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  background: #f1f3f8;
}
::v-deep
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  border: none !important;
}

::v-deep .v-messages {
  display: inline-block !important;
}
::v-deep .v-text-field__details {
  position: absolute;
  bottom: -2.125rem;
  margin-top: 0.75rem !important;
  display: inline-block !important;
}

::v-deep .v-input--selection-controls .v-radio > .v-label {
  font-size: 0.8125rem;
  color: #000;
}
.nonbenefit-toggle-button,
.v-input--radio-group--row {
  ::v-deep .v-messages {
    display: none !important;
  }
}
.nonbenefit-toggle-button,
.price-toggle-button {
  margin: 0;
  padding: 0;
  margin-left: 4.625rem;
  ::v-deep .v-input__slot {
    display: flex;
    flex-direction: row-reverse;
  }
  ::v-deep .v-label {
    font-size: 0.8125rem;
    color: #515257;
    margin-right: 0.5rem;
  }
}
.nonbenefit-pay-input {
  align-items: center;
  ::v-deep .v-input__slot {
    max-width: 21rem;
  }
  ::v-deep label,
  ::v-deep input::placeholder {
    color: #b5b7bf !important;
  }
}

::v-deep .v-input--selection-controls__ripple {
  height: 0;
}
.active-price-toggle-button ::v-deep .v-input--switch__track,
.active-nonbenefit-toggle-button ::v-deep .v-input--switch__track {
  color: #3eb75d !important;
  opacity: 1;
}
.active-price-toggle-button ::v-deep .v-input--switch__thumb,
.active-nonbenefit-toggle-button ::v-deep .v-input--switch__thumb {
  color: #fff !important;
}
::v-deep .v-label,
::v-deep .v-text-field__slot > input::placeholder {
  font-size: 0.875rem;
  color: #b5b7bf;
}
::v-deep .v-text-field__suffix {
  font-size: 0.875rem;
}

// x,y 스크롤바 제거
::v-deep .selected-herb-button-container,
::v-deep .v-select__selections {
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none; /* 인터넷 익스플로러 */
  scrollbar-width: none; /* 파이어폭스 */
}
::v-deep .selected-herb-button-container::-webkit-scrollbar,
::v-deep .v-select__selections::-webkit-scrollbar {
  display: none;
}
</style>
